<script>
  import { fade } from "svelte/transition";
  export let value;
  export let size = 1;
  // 0,58
  $: width = size * 50;
  $: height = width / 0.58;
  export let color = "#000";

  const SYMBOLS = {
    "[": ["top-left", "bottom-left", "top", "bottom"],
    "]": ["top-right", "bottom-right", "top", "bottom"],
    "=": ["top", "bottom"],
    d: ["top-right", "bottom-right", "middle", "bottom", "bottom-left"],
    "-": ["middle"],
    ":": ["top-dot", "bottom-dot"],
    0: [
      "top",
      "top-right",
      "bottom-right",
      "bottom",
      "bottom-left",
      "top-left",
    ],
    1: ["top-right", "bottom-right"],
    2: ["top", "top-right", "middle", "bottom-left", "bottom"],
    3: ["top", "top-right", "bottom-right", "middle", "bottom"],
    4: ["top-right", "bottom-right", "middle", "top-left"],
    5: ["top", "top-left", "middle", "bottom-right", "bottom"],
    6: ["top", "top-left", "bottom-left", "middle", "bottom-right", "bottom"],
    7: ["top", "top-right", "bottom-right"],
    8: [
      "top",
      "top-right",
      "bottom-right",
      "middle",
      "bottom",
      "bottom-left",
      "top-left",
    ],
    9: ["top", "top-right", "bottom-right", "middle", "bottom", "top-left"],
  };

  $: visibleParts = SYMBOLS[String(value)] || [];

  $: top = visibleParts.indexOf("top") != -1;
  $: topRight = visibleParts.indexOf("top-right") != -1;
  $: bottomRight = visibleParts.indexOf("bottom-right") != -1;
  $: bottom = visibleParts.indexOf("bottom") != -1;
  $: bottomLeft = visibleParts.indexOf("bottom-left") != -1;
  $: topLeft = visibleParts.indexOf("top-left") != -1;
  $: middle = visibleParts.indexOf("middle") != -1;
  $: topDot = visibleParts.indexOf("top-dot") != -1;
  $: bottomDot = visibleParts.indexOf("bottom-dot") != -1;
</script>

<style>
  svg {
    margin: 0 6px;
    display: inline-block;
  }
</style>

<svg
  xmlns="http://www.w3.org/2000/svg"
  {width}
  {height}
  viewBox="0 0 59 102"
  style="margin: 0 {width / 10}px;">
  <defs />
  <g fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
    <g id="Back" fill={color} fill-opacity="0.075">
      <path id="middle" d="M5 51.5l6-5.5h37l5.5 5.5-5.51 5.52H11.04z" />
      <path
        id="top-right"
        d="M48 11v30.5l8.5 8.5 2.5-3V6.5l-2.18-3.79L52.5 0z" />
      <path id="top-dot" d="M24 25.02L26 23h7l2 2.02V32l-2 2h-7l-2-2z" />
      <path id="bottom-dot" d="M24 70.02L26 68h7l2 2.02V77l-2 2h-7l-2-2z" />
      <path
        id="bottom-right"
        d="M48 63.17V93.5l8.5 8.5 2.5-2.5v-41l-2.17-3.69-4.33-2.31z"
        transform="matrix(1 0 0 -1 0 154.5)" />
      <path
        id="bottom"
        d="M45 91l4.02 11H5.5c-3.32-2-5.15-4.16-5.5-6.5 1.03-.83 4.36-2.33
        10-4.5h35z" />
      <path id="bottom-left" d="M0 92V56l2.5-3 8.5 8v27z" />
      <path
        id="top-left"
        d="M0 50V13.5L2.5 10l8.5 8.5V46z"
        transform="matrix(1 0 0 -1 0 60)" />
      <path
        id="top"
        d="M49 0l-.01 1.13-4 9.86H11.04L5.75 8.98.05 6.63l2.68-4.02L7 0z" />
    </g>
    <g id="Foreground" fill={color}>
      {#if top}
        <path
          transition:fade={{ duration: 500 }}
          id="top"
          d="M49 0l-.01 1.13-4 9.86H11.04L5.75 8.98.05 6.63l2.68-4.02L7 0z" />
      {/if}
      {#if middle}
        <path
          transition:fade={{ duration: 500 }}
          id="middle"
          d="M5 51.5l6-5.5h37l5.5 5.5-5.51 5.52H11.04z" />
      {/if}
      {#if topRight}
        <path
          transition:fade={{ duration: 500 }}
          id="top-right"
          d="M48 11v30.5l8.5 8.5 2.5-3V6.5l-2.18-3.79L52.5 0z" />
      {/if}
      {#if topDot}
        <path
          transition:fade={{ duration: 500 }}
          id="top-dot"
          d="M24 25.02L26 23h7l2 2.02V32l-2 2h-7l-2-2z" />
      {/if}
      {#if bottomDot}
        <path
          transition:fade={{ duration: 500 }}
          id="bottom-dot"
          d="M24 70.02L26 68h7l2 2.02V77l-2 2h-7l-2-2z" />
      {/if}
      {#if bottomRight}
        <path
          transition:fade={{ duration: 500 }}
          id="bottom-right"
          d="M48 63.17V93.5l8.5 8.5 2.5-2.5v-41l-2.17-3.69-4.33-2.31z"
          transform="matrix(1 0 0 -1 0 154.5)" />
      {/if}
      {#if bottom}
        <path
          transition:fade={{ duration: 500 }}
          id="bottom"
          d="M45 91l4.02 11H5.5c-3.32-2-5.15-4.16-5.5-6.5 1.03-.83 4.36-2.33
          10-4.5h35z" />
      {/if}
      {#if bottomLeft}
        <path
          transition:fade={{ duration: 500 }}
          id="bottom-left"
          d="M0 92V56l2.5-3 8.5 8v27z" />
      {/if}
      {#if topLeft}
        <path
          transition:fade={{ duration: 500 }}
          id="top-left"
          d="M0 50V13.5L2.5 10l8.5 8.5V46z"
          transform="matrix(1 0 0 -1 0 60)" />
      {/if}

    </g>
  </g>
</svg>
